/* Derendo Collection-Testtemplates (A, B, C). Ohne externe Bibliotheken. */
(() => {
  if (window.dcCollectionLoaded) return;
  window.dcCollectionLoaded = true;

  const cartAddUrl = () => ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

  /* Warenkorb öffnen wie im restlichen Shop: Upcart reagiert auf /cart/add.
     Zusätzlich die bekannten Upcart-Funktionen aufrufen, falls vorhanden. */
  const openCart = () => {
    if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    if (typeof window.upcartOpenCart === 'function') {
      window.upcartOpenCart();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  };

  const addItems = async (items) => {
    const res = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) throw new Error('cart add failed');
    const data = await res.json();
    openCart();
    return data;
  };

  /* Kachel: Gebinde wechseln und direkt in den Warenkorb legen */
  if (!customElements.get('dc-buy-box')) {
    customElements.define(
      'dc-buy-box',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.form = this.querySelector('form');
          this.now = this.querySelector('[data-price-now]');
          this.was = this.querySelector('[data-price-was]');
          this.unit = this.querySelector('[data-price-unit]');
          this.button = this.querySelector('.dc-buy__submit');
          this.error = this.querySelector('.dc-buy__error');
          this.unitValue = this.querySelector('[data-unit-value]');
          this.addEventListener('change', (e) => {
            if (e.target.matches('input[type="radio"][name="id"]')) this.update(e.target);
          });
          if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
        }

        update(input) {
          const d = input.dataset;
          this.now.textContent = d.price;
          this.was.textContent = d.compare || '';
          this.was.hidden = !d.compare;
          if (this.unit) {
            this.unit.hidden = !d.unit;
            if (this.unitValue) this.unitValue.textContent = d.unit || '';
          }
          if (this.button) this.button.disabled = d.available !== 'true';
        }

        async submit(e) {
          e.preventDefault();
          const checked = this.form.querySelector('input[name="id"]:checked') || this.form.querySelector('input[name="id"]');
          if (!checked || !this.button) return;
          this.button.setAttribute('aria-busy', 'true');
          this.button.disabled = true;
          if (this.error) this.error.hidden = true;
          try {
            await addItems([{ id: Number(checked.value), quantity: 1 }]);
          } catch (err) {
            if (this.error) this.error.hidden = false;
          } finally {
            this.button.removeAttribute('aria-busy');
            this.button.disabled = false;
          }
        }
      }
    );
  }

  /* Mengenrechner mit Gebinde-Empfehlung */
  if (!customElements.get('dc-calculator')) {
    customElements.define(
      'dc-calculator',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.area = this.querySelector('[data-area]');
          this.coats = this.querySelector('[data-coats]');
          this.product = this.querySelector('[data-product]');
          this.result = this.querySelector('[data-result]');
          this.rec = this.querySelector('[data-rec]');
          this.add = this.querySelector('[data-add]');
          this.status = this.querySelector('[data-status]');
          try {
            this.products = JSON.parse(this.querySelector('[data-products]').textContent);
          } catch (e) {
            this.products = {};
          }
          this.fmt = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
          this.money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
          this.addEventListener('input', () => this.calculate());
          this.addEventListener('change', () => this.calculate());
          this.add.addEventListener('click', () => this.addToCart());
          this.calculate();
        }

        /* Günstigste Kombination, die mindestens die benötigte Menge abdeckt.
           Rechnet in halben Litern, bei gleichem Preis gewinnt die Lösung mit weniger Gebinden. */
        best(need, variants) {
          const sizes = variants.map((v) => ({ ...v, h: Math.round(v.l * 2) })).filter((v) => v.h > 0);
          if (!sizes.length) return null;
          const target = Math.ceil(need * 2);
          const maxH = Math.max(...sizes.map((s) => s.h));
          const limit = target + maxH;
          const cost = new Array(limit + 1).fill(Infinity);
          const count = new Array(limit + 1).fill(Infinity);
          const pick = new Array(limit + 1).fill(-1);
          cost[0] = 0;
          count[0] = 0;
          for (let x = 1; x <= limit; x++) {
            sizes.forEach((s, i) => {
              if (s.h > x || cost[x - s.h] === Infinity) return;
              const c = cost[x - s.h] + s.price;
              const n = count[x - s.h] + 1;
              if (c < cost[x] || (c === cost[x] && n < count[x])) {
                cost[x] = c;
                count[x] = n;
                pick[x] = i;
              }
            });
          }
          let bestX = -1;
          for (let x = target; x <= limit; x++) {
            if (cost[x] === Infinity) continue;
            if (bestX < 0 || cost[x] < cost[bestX] || (cost[x] === cost[bestX] && count[x] < count[bestX])) bestX = x;
          }
          if (bestX < 0) return null;
          const qty = new Map();
          for (let x = bestX; x > 0; x -= sizes[pick[x]].h) {
            const s = sizes[pick[x]];
            qty.set(s.id, { ...s, q: (qty.get(s.id)?.q || 0) + 1 });
          }
          return { items: [...qty.values()].sort((a, b) => b.l - a.l), total: cost[bestX] };
        }

        calculate() {
          const raw = this.area.value.trim();
          this.combo = null;
          this.rec.hidden = true;
          this.add.hidden = true;
          this.status.textContent = '';
          if (!raw) {
            this.result.textContent = this.dataset.empty;
            this.area.removeAttribute('aria-invalid');
            return;
          }
          const area = Number(raw.replace(',', '.'));
          const coats = Number(this.coats.value);
          const coverage = Number(this.dataset.coverage);
          if (!/^\d+(?:[.,]\d+)?$/.test(raw) || !(area > 0) || !(area < 100000)) {
            this.result.textContent = this.dataset.invalid;
            this.area.setAttribute('aria-invalid', 'true');
            return;
          }
          this.area.removeAttribute('aria-invalid');
          const litres = Math.ceil(((area * coats) / coverage) * 10) / 10;
          this.result.textContent = `${this.fmt.format(litres)} ${this.dataset.unit}`;
          const variants = this.products[this.product.value] || [];
          const combo = this.best(litres, variants);
          this.rec.hidden = false;
          if (!combo) {
            this.rec.textContent = this.dataset.none;
            return;
          }
          this.combo = combo;
          const list = combo.items.map((i) => `${i.q} × ${this.fmt.format(i.l)} L`).join(' + ');
          const total = this.money.format(combo.total / 100);
          this.rec.textContent = `${this.dataset.recText.replace('[gebinde]', list)}, ${this.dataset.totalText.replace('[summe]', total)}`;
          this.add.hidden = false;
        }

        async addToCart() {
          if (!this.combo) return;
          this.add.disabled = true;
          this.add.setAttribute('aria-busy', 'true');
          try {
            await addItems(this.combo.items.map((i) => ({ id: i.id, quantity: i.q })));
            this.status.textContent = this.dataset.added;
          } catch (e) {
            this.status.textContent = this.dataset.error;
          } finally {
            this.add.disabled = false;
            this.add.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  /* Rotierende Vorteile-Leiste: nur mobil, nur ohne reduzierte Bewegung */
  const initRotators = () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.dc-usp--rotate').forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      const items = [...bar.querySelectorAll('.dc-usp__item')];
      if (items.length < 2) return;
      let i = 0;
      let paused = false;
      items[0].classList.add('is-active');
      bar.classList.add('is-rotating');
      if (reduce) bar.classList.add('is-static');
      bar.addEventListener('mouseenter', () => (paused = true));
      bar.addEventListener('mouseleave', () => (paused = false));
      bar.addEventListener('focusin', () => (paused = true));
      bar.addEventListener('focusout', () => (paused = false));
      if (reduce) return;
      setInterval(() => {
        if (paused || document.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 3500);
    });
  };

  /* Filter-Chips über die vorhandene Filterlogik laden, ohne Seitenwechsel */
  const facets = () => (typeof FacetFiltersForm !== 'undefined' ? FacetFiltersForm : null);
  const viewParam = () => new URLSearchParams(window.location.search).get('view');

  const markChips = () => {
    const current = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-dc-filter]').forEach((chip) => {
      const wanted = new URLSearchParams(chip.dataset.dcFilter);
      let active = [...wanted.keys()].length > 0;
      wanted.forEach((value, key) => {
        if (!current.getAll(key).includes(value)) active = false;
      });
      if (active) chip.setAttribute('aria-current', 'true');
      else chip.removeAttribute('aria-current');
    });
  };

  const initChips = () => {
    markChips();
    document.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-dc-filter]');
      if (!chip || !facets() || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      const params = chip.getAttribute('aria-current') ? '' : chip.dataset.dcFilter;
      facets().renderPage(params);
      setTimeout(markChips, 50);
      const grid = document.getElementById('ProductGridContainer');
      if (grid && grid.getBoundingClientRect().top < 0) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    window.addEventListener('popstate', () => setTimeout(markChips, 50));
  };

  /* Vorschau über ?view=: beim Filtern den Template-Parameter behalten (facets.js kennt nur das Live-Template) */
  const keepView = () => {
    const view = viewParam();
    const F = facets();
    if (!view || !F || F.dcViewPatched) return;
    const original = F.renderPage;
    F.renderPage = function (searchParams, event, updateURLHash = true) {
      const next = new URLSearchParams(searchParams);
      next.set('view', view);
      return original.call(this, next.toString(), event, updateURLHash);
    };
    F.dcViewPatched = true;
    const origUpdate = F.updateURLHash;
    F.updateURLHash = function (searchParams) {
      origUpdate.call(this, searchParams);
      markChips();
    };
  };

  /* Sticky-Filterleiste unter dem fixierten Header */
  const setStickyTop = () => {
    const header = document.querySelector('.section-header, sticky-header');
    const h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--dc-sticky-top', `${h}px`);
  };

  const init = () => {
    keepView();
    initChips();
    initRotators();
    setStickyTop();
    window.addEventListener('resize', setStickyTop, { passive: true });
  };

  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
